// src/components/OrderConfirmation.js
import React, { useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom'; // 添加 useParams
import styles from '../styles/OrderConfirmation.module.css';

const OrderConfirmation = () => {
  const location = useLocation();
  const { orderId } = useParams(); // 从 URL 中获取订单号
  const { product, paymentMethod } = location.state || { 
    product: { name: '网站C镜像账户', price: '12.49', icon: 'fas fa-robot' }, 
    paymentMethod: 'alipay' 
  };

  const [copiedStates, setCopiedStates] = useState({});

  const handleCopy = (key, value) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopiedStates(prev => ({ ...prev, [key]: true }));
      setTimeout(() => setCopiedStates(prev => ({ ...prev, [key]: false })), 2000);
    });
  };

  // 使用 URL 中的 orderId，如果没有则回退到默认值
  const displayOrderId = orderId || 'ORD-2025030815';

  return (
    <section className={styles.confirmationSection}>
      <div className={styles.container}>
        <div className={styles.confirmationContainer}>
          <div className={styles.confirmationHeader}>
            <i className="fas fa-check-circle"></i>
            <h2>订单提交成功！</h2>
            <p>感谢您的购买！您的订单已成功提交，我们正在处理您的订单，您的账户信息将显示在下方。</p>
          </div>

          <div className={styles.orderDetails}>
            <div className={styles.orderInfo}>
              <div className={styles.orderInfoItem}>
                <h3>订单号</h3>
                <p>{displayOrderId}</p> {/* 使用动态订单号 */}
              </div>
              <div className={styles.orderInfoItem}>
                <h3>订单日期</h3>
                <p>2025年3月8日</p>
              </div>
              <div className={styles.orderInfoItem}>
                <h3>支付状态</h3>
                <p style={{ color: 'var(--success-color)' }}>
                  <i className="fas fa-check-circle"></i> 已支付
                </p>
              </div>
              <div className={styles.orderInfoItem}>
                <h3>交付状态</h3>
                <p>
                  <i className="fas fa-check-circle" style={{ color: 'var(--success-color)' }}></i> 已完成
                </p>
              </div>
            </div>

            <div className={styles.orderSummary}>
              <h3>订单摘要</h3>
              <div className={styles.productList}>
                <div className={styles.productItem}>
                  <div className={styles.productImage}>
                    <i className={product.icon}></i>
                  </div>
                  <div className={styles.productDetails}>
                    <div className={styles.productInfo}>
                      <h4>{product.name}</h4>
                      <p>标准版 - 6个月有效期</p>
                    </div>
                    <div className={styles.productPrice}>¥{product.price}</div>
                  </div>
                </div>
              </div>

              <div className={styles.credentials}>
                <h4>
                  <i className="fas fa-key"></i> 账户信息
                </h4>
                <div className={styles.credentialItem}>
                  <span className={styles.credentialLabel}>登录邮箱:</span>
                  <div className={styles.credentialWrapper}>
                    <span className={styles.credentialValue}>user@example.com</span>
                    <button
                      className={styles.copyBtn}
                      onClick={() => handleCopy('email', 'user@example.com')}
                      title="复制到剪贴板"
                    >
                      {copiedStates['email'] ? <i className="fas fa-check"></i> : <i className="far fa-copy"></i>}
                      {copiedStates['email'] ? ' 已复制' : ''}
                    </button>
                  </div>
                </div>
                <div className={styles.credentialItem}>
                  <span className={styles.credentialLabel}>密码:</span>
                  <div className={styles.credentialWrapper}>
                    <span className={styles.credentialValue}>PaS5w0rd!2025</span>
                    <button
                      className={styles.copyBtn}
                      onClick={() => handleCopy('password', 'PaS5w0rd!2025')}
                      title="复制到剪贴板"
                    >
                      {copiedStates['password'] ? <i className="fas fa-check"></i> : <i className="far fa-copy"></i>}
                      {copiedStates['password'] ? ' 已复制' : ''}
                    </button>
                  </div>
                </div>
                <div className={styles.credentialItem}>
                  <span className={styles.credentialLabel}>访问链接:</span>
                  <div className={styles.credentialWrapper}>
                    <span className={styles.credentialValue}>https://website-c.example.com/login</span>
                    <button
                      className={styles.copyBtn}
                      onClick={() => handleCopy('link', 'https://website-c.example.com/login')}
                      title="复制到剪贴板"
                    >
                      {copiedStates['link'] ? <i className="fas fa-check"></i> : <i className="far fa-copy"></i>}
                      {copiedStates['link'] ? ' 已复制' : ''}
                    </button>
                  </div>
                </div>
              </div>

              <div className={styles.priceDetails}>
                <div className={styles.priceRow}>
                  <span>小计</span>
                  <span>¥{product.price}</span>
                </div>
                <div className={styles.priceRow}>
                  <span>总计</span>
                  <span>¥{product.price}</span>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.paymentDetails}>
            <h3>支付详情</h3>
            <div className={styles.paymentInfo}>
              <div className={styles.paymentInfoItem}>
                <h4>支付方式</h4>
                <p>{paymentMethod === 'alipay' ? '支付宝' : paymentMethod}</p>
              </div>
              <div className={styles.paymentInfoItem}>
                <h4>支付金额</h4>
                <p>¥{product.price}</p>
              </div>
              <div className={styles.paymentInfoItem}>
                <h4>支付时间</h4>
                <p>2025年3月8日 14:35</p>
              </div>
            </div>
          </div>

          <div className={styles.deliveryInfo}>
            <h3>交付信息</h3>
            <div className={styles.deliveryContent}>
              <div className={styles.deliveryIcon}>
                <i className="fas fa-envelope"></i>
              </div>
              <div className={styles.deliveryText}>
                <p>您的账户信息已通过 <span className={styles.highlight}>电子邮件</span> 发送至 <span className={styles.highlight}>user@example.com</span>。</p>
                <p>您也可以在 <Link to="/account">账户中心</Link> 查看和管理您的订单。</p>
              </div>
            </div>
          </div>

          <div className={styles.actionButtons}>
            <Link to="/account" className={styles.btn}>查看我的账户</Link>
            <Link to="/" className={`${styles.btn} ${styles.btnOutline}`}>返回首页</Link>
          </div>

          <div className={styles.helpText}>
            需要帮助？请 <a href="mailto:support@example.com">联系我们</a> 或查看 <a href="/faq">常见问题</a>。
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderConfirmation;